import { PageSection } from '@/components/common/PageSection';
import { SectionHeading } from '@/components/common/SectionHeading';
import { Process } from '@/pages/Home/data';

const SectionId = 'process';
const TitleId = 'process-title';

export function ProcessSection() {
  return (
    <PageSection id={SectionId} titleId={TitleId} tone="pad" focusable>
      <SectionHeading id={TitleId} title={Process.title} description={Process.description} />
      <ol className="mt-12 grid gap-8 lg:grid-cols-4 lg:gap-8">
        {Process.steps.map((step, stepIndex) => (
          <li
            key={step.title}
            className="relative flex gap-5 before:absolute before:left-[1.0625rem] before:top-11 before:-bottom-6 before:w-0.5 before:bg-grid last:before:hidden lg:block lg:before:hidden lg:after:absolute lg:after:left-12 lg:after:-right-5 lg:after:top-[1.0625rem] lg:after:h-0.5 lg:after:bg-grid lg:last:after:hidden"
          >
            <span
              aria-hidden="true"
              className="flex size-9 shrink-0 items-center justify-center rounded-full border-2 border-redline bg-pad-light text-sm font-bold text-redline"
            >
              {stepIndex + 1}
            </span>
            <div className="pb-2 lg:mt-5 lg:pb-0">
              <h3 className="text-lg font-bold text-graphite">{step.title}</h3>
              <p className="mt-2 max-w-[48ch] leading-relaxed text-steel">{step.description}</p>
            </div>
          </li>
        ))}
      </ol>
    </PageSection>
  );
}